import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.diet;

const getDiet = createSelector(getData, diet => values(diet));

export default getDiet;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getDiet.js